// Rendering result cards
import { encodeFilePath } from '../../../files/file-list.utils.js';
import { getEffectiveSizeBytes, formatBytes, escapeHtml } from '../helpers.js';
import { formatFileTags } from './tag-formatter.js';

/**
 * Create a result card element
 */
export function createResultCard(item, idx, currentPage, itemsPerPage, hasSummaries) {
    const globalIndex = (itemsPerPage * (currentPage - 1)) + idx + 1;
    const linkKey = (item.link || item.path || '').replace(/^\/+/, '');
    const nameKey = (item.name || linkKey.split('/').pop() || '').toString();
    
    const el = document.createElement('div'); 
    el.className = 'fulltext-result-card search-result-item pt-3 pb-2 pt-md-4 pb-md-3 border-bottom';
    
    const hasOnline = !!(item.o === 1 || item.online === 1);
    const isOT = !!(item.ot || item.ot_level || (typeof item.category === 'string' && item.category.toUpperCase() === 'OT'));
    
    let href;
    if (hasOnline && linkKey.toLowerCase().match(/\.(doc|docx)$/)) {
        href = `/online/${encodeFilePath(linkKey)}`;
    } else if (isOT) {
        href = `/library/${encodeFilePath(linkKey)}?ot=1`;
    } else {
        href = `/library/${encodeFilePath(linkKey)}`;
    }
    
    const title = item.name || item.title || item.path || 'Document';
    const sizeBytes = getEffectiveSizeBytes(item);
    const sizeStr = sizeBytes > 0 ? formatBytes(sizeBytes) : '';
    const snippet = (item.snippet || item.content || '').toString();
    const tagsHtml = formatFileTags(item, linkKey);
    const isMissing = item.missing === true;
    
    if (isMissing) el.classList.add('fulltext-result-missing');
    
    el.setAttribute('data-key', linkKey);
    el.setAttribute('data-name', title);
    el.setAttribute('data-path', linkKey);
    
    const titleHtml = isMissing 
        ? `<h6 class="m-0 text-muted" style="text-decoration: line-through; cursor: not-allowed;">${escapeHtml(title)}</h6>`
        : `<a href="${href}" target="_blank" class="fulltext-result-title text-decoration-none"><h6 class="m-0">${escapeHtml(title)}</h6></a>`;
    
    const missingNotice = isMissing 
        ? `<div class="fulltext-missing-notice text-muted small mt-1"><i class="bi bi-exclamation-triangle"></i> File not found. Will be fixed in upcoming update.</div>`
        : '';
    
    const hasSummary = hasSummaries.has(linkKey) || hasSummaries.has(nameKey);
    
    el.innerHTML = `
        <div class="fulltext-index" aria-hidden="true">${globalIndex}</div>
        <div class="d-flex flex-column gap-1 flex-grow-1">
          ${titleHtml}
          ${missingNotice}
          <div class="fulltext-result-snippet text-muted">${snippet}</div>
          <div class="fulltext-result-meta d-flex flex-wrap gap-3 text-secondary">
            ${tagsHtml}
            ${sizeStr ? `<span class=\"fulltext-size-badge\" title=\"File size\">${sizeStr}</span>` : ''}
            <button type="button" class="fulltext-meta-chip fulltext-summary__chip ${hasSummary ? '' : 'd-none'}" aria-expanded="false" title="AI summary"><i class="bi bi-anthropic"></i></button>
          </div>
          <div class="fulltext-summary d-none" data-summary-for="${escapeHtml(linkKey)}" data-name-key="${escapeHtml(nameKey)}">
            <div class="fulltext-summary__text"></div>
          </div>
        </div>`;
        
    return el;
}
